import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { SvgImage } from 'components/SvgImage'

import {
  getUserStatusAction,
  setUUIDAndSendUserConfigAction,
} from 'root-redux/actions/user'
import {
  selectExistingUUIDByEmail,
  selectUUID,
  selectUserStatus,
} from 'root-redux/selects/user'
import { TAppDispatch } from 'root-redux/store/store'

import { eventLogger } from 'services/eventLogger.service'

import envelopeIcon from 'assets/images/sprite/grey-envelope.svg'

import { StyledCheckInbox as S } from './CheckInbox.styles'

export const CheckInbox: React.FC = () => {
  const { t } = useTranslation()
  const dispatch: TAppDispatch = useDispatch()
  const uuid = useSelector(selectUUID)
  const userStatus = useSelector(selectUserStatus)
  const existingUuid = useSelector(selectExistingUUIDByEmail)

  useEffect(() => {
    eventLogger.logCheckYourInboxScreenShow()
  }, [])

  useEffect(() => {
    dispatch(getUserStatusAction(uuid))
  }, [dispatch, uuid])

  const handleContinue = useCallback(async () => {
    eventLogger.logCheckYourInboxContinueTap()

    const targetUuid = existingUuid || userStatus?.config.targetUuid
    if (!targetUuid) return

    const isConfigSaved = await dispatch(
      setUUIDAndSendUserConfigAction(targetUuid, {
        target_uuid: targetUuid,
      }),
    )
    if (!isConfigSaved) return

    dispatch(getUserStatusAction(targetUuid))
  }, [dispatch, existingUuid, userStatus?.config.targetUuid])

  return (
    <S.Container>
      <S.Content>
        <SvgImage svg={envelopeIcon} width={80} height={60} />
        <S.Title>{t('onboarding.email.checkInbox.title')}</S.Title>
        <S.Text>{t('onboarding.email.checkInbox.info1')}</S.Text>
        <S.Text>{t('onboarding.email.checkInbox.info2')}</S.Text>
      </S.Content>

      <S.Footer>
        <S.Button type="button" onClick={handleContinue}>
          {t('actions.continue')}
        </S.Button>
      </S.Footer>
    </S.Container>
  )
}
